module.exports = __webpack_public_path__ + "img/customer-tips.a27b7cdc.svg";